module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h1', {
    staticClass: "title has-text-centered is-size-1 has-text-weight-light"
  }, [_vm._v("\n    " + _vm._s(_vm.$t('index.administrating_objects')) + "\n    "), _c('span', {
    staticClass: "has-text-info icon is-large",
    class: {
      'fa-spin': _vm.isloading
    },
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": _vm.loadData
    }
  }, [_c('i', {
    staticClass: "fas fa-sync"
  })])]), _vm._v(" "), _c('b-loading', {
    attrs: {
      "is-full-page": true,
      "active": _vm.isloading,
      "can-cancel": false
    },
    on: {
      "update:active": function($event) {
        _vm.isloading = $event
      }
    }
  }), _vm._v(" "), (_vm.initResponse.canAdminGlobal) ? _c('div', {
    staticClass: "columns is-multiline"
  }, _vm._l((_vm.initResponse.objects), function(object, index) {
    return (object.canAdmin) ? _c('div', {
      key: index,
      staticClass: "column is-10 is-offset-1 is-narrow",
      attrs: {
        "selected": index === 0
      }
    }, [_c('article', {
      staticClass: "tile is-child box"
    }, [_c('p', {
      staticClass: "is-size-2 has-text-weight-light"
    }, [_c('span', [_vm._v(_vm._s(object.name))])]), _vm._v(" "), (object.tariffData.maxConfigs != 999999) ? [_c('p', {
      staticClass: "is-size-4 has-text-weight-light"
    }, [_vm._v("\n            " + _vm._s(_vm.$t('index.license_info_' + object.byod_type, {
      license: object.tariffData.name,
      rooms: object.tariffData.inUseConfigs,
      roomstotal: object.tariffData.maxConfigs
    })) + "\n          ")])] : [_c('p', {
      staticClass: "is-size-4 has-text-weight-light"
    }, [_vm._v("License " + _vm._s(object.tariffData.name) + " (unlimited rooms)")])], _vm._v(" "), _c('br'), _vm._v(" "), _c('collapse', {
      attrs: {
        "accordion": "",
        "is-fullwidth": ""
      }
    }, _vm._l((_vm.initResponse.projectsAdminData[object.id]), function(tag, tagI) {
      return _c('collapse-item', {
        key: tagI,
        staticClass: "tab-head-custom",
        attrs: {
          "title": tagI
        }
      }, [_c('tabs', {
        attrs: {
          "type": "tabs is-medium "
        }
      }, [_c('tab-pane', {
        attrs: {
          "label": _vm.$t('index.rooms_' + object.byod_type)
        }
      }, [_c('div', {
        staticClass: "wrap_table"
      }, [_c('table', {
        staticClass: "table is-striped is-fullwidth is-narrow"
      }, [_vm._l((tag.configurations), function(confPropVal, confPropKey) {
        return _c('tr', {
          key: confPropKey
        }, [_c('td', [(!confPropVal.edit) ? _c('span', [_vm._v("\n                          " + _vm._s(confPropVal.name) + "\n                        ")]) : _vm._e(), _vm._v(" "), (confPropVal.edit) ? _c('div', {
          staticClass: "field"
        }, [_c('p', {
          staticClass: "control"
        }, [_c('input', {
          directives: [{
            name: "model",
            rawName: "v-model",
            value: (confPropVal.newName),
            expression: "confPropVal.newName"
          }],
          staticClass: "input is-primary",
          staticStyle: {
            "width": "90%"
          },
          attrs: {
            "type": "text",
            "placeholder": _vm.$t('index.unique_configuration_name')
          },
          domProps: {
            "value": (confPropVal.newName)
          },
          on: {
            "keypress": function($event) {
              if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
              _vm.editConfig(confPropVal, confPropVal.newName)
            },
            "input": function($event) {
              if ($event.target.composing) { return; }
              _vm.$set(confPropVal, "newName", $event.target.value)
            }
          }
        }), _vm._v(" "), _c('span', {
          staticClass: "pointer edit-icon",
          on: {
            "click": function($event) {
              _vm.editConfig(confPropVal, confPropVal.newName)
            }
          }
        }, [_c('i', {
          staticClass: "fas fa-lg fa-check"
        })]), _vm._v(" "), _c('span', {
          staticClass: "pointer edit-icon",
          on: {
            "click": function($event) {
              confPropVal.edit = false
            }
          }
        }, [_c('i', {
          staticClass: "fas fa-lg fa-times-circle"
        })])])]) : _vm._e(), _vm._v(" "), (!confPropVal.edit) ? _c('span', {
          staticClass: "pointer icon",
          on: {
            "click": function($event) {
              _vm.showEditConf(object.id, tagI, confPropVal.id)
            }
          }
        }, [_c('i', {
          staticClass: "fas fa-pencil-alt"
        })]) : _vm._e()]), _vm._v(" "), _c('td', [_c('FDateTime', {
          attrs: {
            "value": confPropVal.updatedAt
          }
        })], 1), _vm._v(" "), _c('td', {}, [_c('a', {
          staticClass: "button is-outlined is-small",
          on: {
            "click": function($event) {
              _vm.showRoomFieldsManager(confPropVal)
            }
          }
        }, [_c('span', {
          staticClass: "icon is-small"
        }, [_c('i', {
          staticClass: "fa fa-th-list"
        })]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$t('index.set_fields')))])]), _vm._v(" "), _c('a', {
          staticClass: "button is-outlined is-small",
          on: {
            "click": function($event) {
              _vm.showDeleteRoom(confPropVal)
            }
          }
        }, [_c('span', {
          staticClass: "icon is-small"
        }, [_c('i', {
          staticClass: "fa fa-times"
        })]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$t('index.delete')))])]), _vm._v(" "), _c('div', {
          class: ['modal deleteConfigModal', confPropVal.deletePopup ? 'is-active' : ''],
          staticStyle: {
            "text-align": "left"
          }
        }, [_c('div', {
          staticClass: "modal-background"
        }), _vm._v(" "), _c('div', {
          staticClass: "modal-content"
        }, [_vm._v("\n                            " + _vm._s(_vm.$t('index.delete_configuration_confirm', {
          confname: confPropVal.name,
          conftag: confPropVal.tag
        })) + "\n                            "), _c('br'), _vm._v(" "), _c('span', {
          staticClass: "tag is-danger"
        }, [_vm._v(_vm._s(_vm.$t('index.delete_configuration_warning')))])]), _vm._v(" "), _c('button', {
          staticClass: "button is-text",
          on: {
            "click": function($event) {
              confPropVal.deletePopup = false
            }
          }
        }, [_vm._v(_vm._s(_vm.$t('index.cancel')))]), _vm._v(" "), _c('button', {
          staticClass: "button is-danger",
          on: {
            "click": function($event) {
              _vm.deleteConfig(confPropVal)
            }
          }
        }, [_vm._v(_vm._s(_vm.$t('index.yes')))])])])])
      }), _vm._v(" "), _c('tr', [(tag.newConfigInputShow) ? _c('td', [_c('div', {
        staticClass: "field"
      }, [_c('div', {
        staticClass: "control"
      }, [_c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (tag.newConfigInputText),
          expression: "tag.newConfigInputText"
        }],
        staticClass: "input is-primary",
        attrs: {
          "type": "text",
          "placeholder": _vm.$t('index.unique_configuration_name')
        },
        domProps: {
          "value": (tag.newConfigInputText)
        },
        on: {
          "keypress": function($event) {
            if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
            _vm.addNewConfig(object.id, tagI)
          },
          "input": function($event) {
            if ($event.target.composing) { return; }
            _vm.$set(tag, "newConfigInputText", $event.target.value)
          }
        }
      })])])]) : _vm._e(), _vm._v(" "), (tag.newConfigInputShow) ? _c('td', [_c('span', {
        staticClass: "pointer",
        on: {
          "click": function($event) {
            _vm.addNewConfig(object.id, tagI)
          }
        }
      }, [_c('i', {
        staticClass: "fa fa-lg fa-check"
      })]), _vm._v(" "), _c('span', {
        staticClass: "pointer",
        on: {
          "click": function($event) {
            tag.newConfigInputShow = false
          }
        }
      }, [_c('i', {
        staticClass: "fa fa-lg fa-times-circle"
      })])]) : _vm._e()])], 2)]), _vm._v(" "), (!tag.newConfigInputShow) ? _c('a', {
        staticClass: "button is-info is-small",
        on: {
          "click": function($event) {
            _vm.showNewConfigInput(object, tagI, tag)
          }
        }
      }, [_c('span', {
        staticClass: "icon is-small"
      }, [_c('i', {
        staticClass: "fa fa-plus"
      })]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$t('index.add_new')))])]) : _vm._e()]), _vm._v(" "), _c('tab-pane', {
        attrs: {
          "label": _vm.$t('index.projects')
        }
      }, [_c('div', {
        staticClass: "wrap_table"
      }, [_c('table', {
        staticClass: "table is-striped is-fullwidth"
      }, _vm._l((tag.projects), function(tagPropVal, tagPropKey) {
        return _c('tr', {
          key: tagPropKey
        }, [_c('td', [_vm._v(_vm._s(tagPropVal.name))]), _vm._v(" "), _c('td', [_c('FDateTime', {
          attrs: {
            "value": tagPropVal.updatedAt
          }
        })], 1)])
      }))])])], 1), _vm._v(" "), _c('section', {
        staticClass: "has-text-right"
      }, [_c('button', {
        staticClass: "button is-default",
        on: {
          "click": function($event) {
            _vm.showFieldsManager(tagI, object.id)
          }
        }
      }, [_vm._v(_vm._s(_vm.$t('index.fields')))])])], 1)
    })), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
      staticClass: "columns"
    }, [_c('div', {
      staticClass: "column"
    }, [(object.byod_type !== 'mauth') ? _c('b-collapse', {
      staticClass: "object-collapse",
      attrs: {
        "open": false
      }
    }, [_c('button', {
      staticClass: "button",
      attrs: {
        "slot": "trigger"
      },
      slot: "trigger"
    }, [_c('span', {
      staticClass: "icon"
    }, [_c('i', {
      staticClass: "fa fa-cog"
    })]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$t('index.settings')))])]), _vm._v(" "), _c('div', {
      staticClass: "notification"
    }, [_c('div', {
      staticClass: "content"
    }, [_c('div', {
      staticClass: "columns"
    }, [_c('div', {
      staticClass: "column"
    }, [_c('b-field', {
      attrs: {
        "label": _vm.$t('index.default_arrival_time_' + object.byod_type)
      }
    }, [_c('b-timepicker', {
      attrs: {
        "hour-format": "24",
        "placeholder": "Type or select a time...",
        "icon": "clock",
        "readonly": false
      },
      model: {
        value: (object.defArrivalTime),
        callback: function($$v) {
          _vm.$set(object, "defArrivalTime", $$v)
        },
        expression: "object.defArrivalTime"
      }
    })], 1)], 1), _vm._v(" "), _c('div', {
      staticClass: "column"
    }, [_c('b-field', {
      attrs: {
        "label": _vm.$t('index.default_departure_time_' + object.byod_type)
      }
    }, [_c('b-timepicker', {
      attrs: {
        "hour-format": "24",
        "placeholder": "Type or select a time...",
        "icon": "clock",
        "readonly": false
      },
      model: {
        value: (object.defDepartureTime),
        callback: function($$v) {
          _vm.$set(object, "defDepartureTime", $$v)
        },
        expression: "object.defDepartureTime"
      }
    })], 1)], 1)]), _vm._v(" "), _c('div', {
      staticClass: "columns"
    }, [_c('div', {
      staticClass: "column"
    }, [_c('b-switch', {
      attrs: {
        "type": "is-success"
      },
      model: {
        value: (object.showQrCode),
        callback: function($$v) {
          _vm.$set(object, "showQrCode", $$v)
        },
        expression: "object.showQrCode"
      }
    }, [_vm._v("\n                        " + _vm._s(_vm.$t('index.show_qr_after_reg')) + "\n                      ")])], 1), _vm._v(" "), _c('div', {
      staticClass: "column"
    }, [_c('b-switch', {
      attrs: {
        "type": "is-success"
      },
      model: {
        value: (object.multyTokensConfig),
        callback: function($$v) {
          _vm.$set(object, "multyTokensConfig", $$v)
        },
        expression: "object.multyTokensConfig"
      }
    }, [_vm._v(" Multiple tokens in one configuration ")])], 1)]), _vm._v(" "), _c('div', {
      staticClass: "columns"
    }, [_c('div', {
      staticClass: "column"
    }, [_c('b-field', {
      attrs: {
        "label": _vm.$t('index.def_check_frequency')
      }
    }, [_c('b-input', {
      attrs: {
        "type": "number",
        "min": "1",
        "max": "7",
        "icon": "clock",
        "placeholder": _vm.$t('index.days')
      },
      model: {
        value: (object.defFrequencyCheckPeriod),
        callback: function($$v) {
          _vm.$set(object, "defFrequencyCheckPeriod", $$v)
        },
        expression: "object.defFrequencyCheckPeriod"
      }
    })], 1)], 1), _vm._v(" "), _c('div', {
      staticClass: "column"
    }, [_c('b-field', {
      attrs: {
        "label": _vm.$t('index.def_activation_panels_limit')
      }
    }, [_c('b-input', {
      attrs: {
        "placeholder": _vm.$t('index.activation_panels_limit_placeholder'),
        "type": "number",
        "min": "1",
        "icon": "clock"
      },
      model: {
        value: (object.defActivationsCount),
        callback: function($$v) {
          _vm.$set(object, "defActivationsCount", $$v)
        },
        expression: "object.defActivationsCount"
      }
    })], 1)], 1)]), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('b-loading', {
      attrs: {
        "is-full-page": false,
        "active": _vm.uploadInProcess,
        "can-cancel": false
      },
      on: {
        "update:active": function($event) {
          _vm.uploadInProcess = $event
        }
      }
    }), _vm._v(" "), _c('b-field', {
      attrs: {
        "label": _vm.$t('index.import_settings_from_csv')
      }
    }, [_c('b-field', [_c('b-upload', {
      attrs: {
        "accept": ".csv",
        "loading": _vm.uploadInProcess
      },
      model: {
        value: (_vm.file),
        callback: function($$v) {
          _vm.file = $$v
        },
        expression: "file"
      }
    }, [_c('a', {
      staticClass: "button is-info is-right"
    }, [_c('b-icon', {
      attrs: {
        "icon": "upload"
      }
    }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$t('index.upload_file')))])], 1)]), _vm._v(" "), (_vm.file.name) ? _c('span', {
      staticClass: "file-name"
    }, [_vm._v("\n                        " + _vm._s(_vm.file.name) + "\n                      ")]) : _vm._e()], 1)], 1), _vm._v(" "), _c('div', {
      staticClass: "buttons has-addons"
    }, [(_vm.file.name) ? _c('button', {
      staticClass: "button",
      on: {
        "click": function($event) {
          _vm.upload(object)
        }
      }
    }, [_vm._v("upload")]) : _vm._e(), _vm._v(" "), _c('a', {
      staticClass: "button is-text",
      attrs: {
        "target": "_blank",
        "download": "",
        "href": "https://s3.amazonaws.com/licensetext/import_template.csv"
      }
    }, [_vm._v(_vm._s(_vm.$t('index.download_csv_template')))])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
      staticClass: "buttons is-right"
    }, [_c('button', {
      staticClass: "button is-success",
      on: {
        "click": function($event) {
          _vm.saveSettings(object)
        }
      }
    }, [_c('span', {
      staticClass: "icon"
    }, [_c('i', {
      staticClass: "fa fa-check"
    })]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$t('index.save')))])])])], 1)])]) : _vm._e(), _vm._v(" "), (object.byod_type == 'mauth') ? _c('b-collapse', {
      staticClass: "object-collapse",
      attrs: {
        "open": object.sms.collapse
      },
      on: {
        "update:open": function($event) {
          _vm.$set(object.sms, "collapse", $event)
        },
        "open": function($event) {
          _vm.loadSMS(object)
        }
      }
    }, [_c('button', {
      staticClass: "button",
      attrs: {
        "slot": "trigger"
      },
      slot: "trigger"
    }, [_c('span', {
      staticClass: "icon"
    }, [_c('i', {
      staticClass: "fa fa-phone"
    })]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$t('index.object_settings.sms_label')))])]), _vm._v(" "), _c('div', {
      staticClass: "notification"
    }, [_c('div', {
      staticClass: "content"
    }, [_c('div', {
      staticClass: "columns"
    }, [_c('div', {
      staticClass: "column"
    }, [_c('b-field', {
      attrs: {
        "label": "СМС-провайдер"
      }
    }, [_c('div', {
      staticClass: "select"
    }, [_c('select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (object.sms.provider),
        expression: "object.sms.provider"
      }],
      on: {
        "change": [function($event) {
          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return val
          });
          _vm.$set(object.sms, "provider", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
        }, function($event) {
          _vm.changeProvider(object)
        }]
      }
    }, [_c('option', {
      attrs: {
        "value": "smsgorod"
      }
    }, [_vm._v("smsgorod.ru")]), _vm._v(" "), _c('option', {
      attrs: {
        "value": "smsc"
      }
    }, [_vm._v("smsc.ru")])])])])], 1)]), _vm._v(" "), (object.sms.provider == 'smsc') ? _c('section', {
      key: "smsc"
    }, [_c('div', {
      staticClass: "columns"
    }, [_c('div', {
      staticClass: "column"
    }, [_c('b-field', {
      attrs: {
        "label": _vm.$t('index.object_settings.sms_login'),
        "type": {
          'is-danger': !object.sms.credentials.login || !object.sms.balance
        },
        "message": ( _obj = {}, _obj[_vm.$t('index.profile.errors.fill_this_field')] = !object.sms.credentials.login, _obj )
      }
    }, [_c('b-input', {
      attrs: {
        "type": "text"
      },
      model: {
        value: (object.sms.credentials.login),
        callback: function($$v) {
          _vm.$set(object.sms.credentials, "login", $$v)
        },
        expression: "object.sms.credentials.login"
      }
    })], 1)], 1)]), _vm._v(" "), _c('div', {
      staticClass: "columns"
    }, [_c('div', {
      staticClass: "column"
    }, [_c('b-field', {
      attrs: {
        "label": _vm.$t('index.object_settings.sms_password'),
        "type": {
          'is-danger': !object.sms.credentials.password || !object.sms.balance
        },
        "message": ( _obj$1 = {}, _obj$1[_vm.$t('index.profile.errors.fill_this_field')] = !object.sms.credentials.password, _obj$1 )
      }
    }, [_c('b-input', {
      attrs: {
        "type": "password",
        "password-reveal": ""
      },
      model: {
        value: (object.sms.credentials.password),
        callback: function($$v) {
          _vm.$set(object.sms.credentials, "password", $$v)
        },
        expression: "object.sms.credentials.password"
      }
    })], 1)], 1)]), _vm._v(" "), (object.sms.balance) ? _c('div', {
      staticClass: "columns"
    }, [_c('div', {
      staticClass: "column"
    }, [_c('b-field', {
      attrs: {
        "label": _vm.$t('index.object_settings.sms_balance')
      }
    }, [_c('b-input', {
      attrs: {
        "type": "text",
        "readonly": "",
        "disabled": "",
        "value": ((object.sms.balance) + " ₽")
      }
    })], 1)], 1)]) : _vm._e()]) : _vm._e(), _vm._v(" "), (object.sms.provider == 'smsgorod') ? _c('section', {
      key: "smsgorod"
    }, [_c('div', {
      staticClass: "columns"
    }, [_c('div', {
      staticClass: "column"
    }, [_c('b-field', {
      attrs: {
        "label": "API Key",
        "type": {
          'is-danger': !object.sms.credentials.apiKey || !object.sms.balance
        },
        "message": ( _obj$2 = {}, _obj$2[_vm.$t('index.profile.errors.fill_this_field')] = !object.sms.credentials.apiKey, _obj$2 )
      }
    }, [_c('b-input', {
      attrs: {
        "type": "text"
      },
      model: {
        value: (object.sms.credentials.apiKey),
        callback: function($$v) {
          _vm.$set(object.sms.credentials, "apiKey", $$v)
        },
        expression: "object.sms.credentials.apiKey"
      }
    })], 1)], 1)]), _vm._v(" "), (object.sms.balance) ? _c('div', {
      staticClass: "columns"
    }, [_c('div', {
      staticClass: "column"
    }, [_c('b-field', {
      attrs: {
        "label": _vm.$t('index.object_settings.sms_balance')
      }
    }, [_c('b-input', {
      attrs: {
        "type": "text",
        "readonly": "",
        "disabled": "",
        "value": ((object.sms.balance) + " ₽")
      }
    })], 1)], 1)]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "buttons is-right"
    }, [(object.sms.balance) ? _c('button', {
      staticClass: "button is-primary",
      on: {
        "click": function($event) {
          _vm.testSMS(object)
        }
      }
    }, [_c('span', {
      staticClass: "icon"
    }, [_c('i', {
      staticClass: "fa fa-comment"
    })]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$t('index.object_settings.test_sms')))])]) : _vm._e(), _vm._v(" "), _c('button', {
      staticClass: "button is-success",
      on: {
        "click": function($event) {
          _vm.saveSMS(object)
        }
      }
    }, [_c('span', {
      staticClass: "icon"
    }, [_c('i', {
      staticClass: "fa fa-check"
    })]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$t('index.object_settings.save_sms')))])]), _vm._v(" "), (object.sms.balance) ? _c('button', {
      staticClass: "button is-danger",
      on: {
        "click": function($event) {
          _vm.deleteSMS(object)
        }
      }
    }, [_c('span', {
      staticClass: "icon"
    }, [_c('i', {
      staticClass: "fa fa-ban"
    })]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$t('index.object_settings.clear_sms')))])]) : _vm._e()]), _vm._v(" "), (object && object.sms && object.sms.open) ? _c('div', {
      staticClass: "columns"
    }, [_c('div', {
      staticClass: "column"
    }, [_c('b-field', {
      attrs: {
        "label": _vm.$t('index.object_settings.sms_phone'),
        "type": {
          'is-danger': !object.sms.phone
        },
        "message": ( _obj$3 = {}, _obj$3[_vm.$t('index.profile.errors.fill_this_field')] = !object.sms.phone, _obj$3 )
      }
    }, [_c('b-input', {
      attrs: {
        "type": "text"
      },
      model: {
        value: (object.sms.phone),
        callback: function($$v) {
          _vm.$set(object.sms, "phone", $$v)
        },
        expression: "object.sms.phone"
      }
    })], 1), _vm._v(" "), _c('button', {
      staticClass: "button is-warning",
      on: {
        "click": function($event) {
          _vm.sendSMS(object)
        }
      }
    }, [_c('span', {
      staticClass: "icon"
    }, [_c('i', {
      staticClass: "fa fa-paper-plane"
    })]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$t('index.object_settings.send_sms')))])])], 1)]) : _vm._e()])])]) : _vm._e()], 1)])], 2)]) : _vm._e()
    var _obj;
    var _obj$1;
    var _obj$2;
    var _obj$3;
  })) : _vm._e(), _vm._v(" "), _c('b-modal', {
    attrs: {
      "active": _vm.showTagFieldsData,
      "has-modal-card": ""
    },
    on: {
      "update:active": function($event) {
        _vm.showTagFieldsData = $event
      }
    }
  }, [_c('tagfields', _vm._b({
    on: {
      "create_room_fields": _vm.showRoomFieldsManager
    }
  }, 'tagfields', _vm.tagFieldsData, false))], 1), _vm._v(" "), _c('b-modal', {
    attrs: {
      "active": _vm.showRoomFieldsData
    },
    on: {
      "update:active": function($event) {
        _vm.showRoomFieldsData = $event
      }
    }
  }, [_c('roomfields', _vm._b({
    on: {
      "create_config_fields": _vm.showFieldsManagerFromRooms
    }
  }, 'roomfields', _vm.roomFieldsData, false))], 1), _vm._v(" "), _c('b-modal', {
    staticClass: "config-csv-modal",
    attrs: {
      "active": _vm.showImportedFieldsData,
      "has-modal-card": ""
    },
    on: {
      "update:active": function($event) {
        _vm.showImportedFieldsData = $event
      }
    }
  }, [_c('importfields', _vm._b({
    on: {
      "import_fields": _vm.successImportFieldsEmit
    }
  }, 'importfields', _vm.importedFields, false))], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-167db288"}!./~/vue-loader/lib/selector.js?type=template&index=0!./client/views/administration_manager/index.vue
// module id = 300
// module chunks = 2